(function () {
  if (window.oettingerLoadMoreBound) return;
  window.oettingerLoadMoreBound = true;

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var button = target.closest('[data-oettinger-load-more-button]');
    if (!button) return;

    var wrapper = button.closest('[data-oettinger-load-more]');
    if (!wrapper) return;

    var gridId = wrapper.dataset.gridId;
    var grid = gridId ? document.getElementById(gridId) : null;
    if (!grid) return;

    var total = parseInt(wrapper.dataset.total, 10);
    var shown = parseInt(wrapper.dataset.shown, 10);
    var batch = parseInt(wrapper.dataset.batch, 10);

    if (!Number.isFinite(total)) total = grid.children.length;
    if (!Number.isFinite(shown)) shown = 0;
    if (!Number.isFinite(batch) || batch < 1) batch = 4;

    var hidden = grid.querySelectorAll('.oettinger-lm-hidden');
    var count = Math.min(batch, hidden.length);

    for (var i = 0; i < count; i++) {
      hidden[i].classList.remove('oettinger-lm-hidden');
    }

    shown += count;
    wrapper.dataset.shown = String(shown);

    if (shown >= total || !grid.querySelector('.oettinger-lm-hidden')) {
      wrapper.hidden = true;
    }
  });
})();
